import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NOT_FOUND_PATH } from 'routes/constants';
import { useDispatch, useSelector } from 'store';
import { clearNotFound } from 'store/reducers/notFound';

// Mounted once at the App level (above MainLayout / the auth boundary) so it survives
// logout/login and route changes — there's no remount window where a stale triggerKey
// could fire a phantom navigation.
const NotFoundRedirect = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const triggerKey = useSelector((state) => state.notFound.triggerKey);

    useEffect(() => {
        if (!triggerKey) return;
        if (pathname !== NOT_FOUND_PATH) {
            navigate(NOT_FOUND_PATH, { replace: true });
        }
        // Always clear — even if no navigation happened (already on /404) — so a fresh
        // trigger for the same broken URL after the user navigates away and back can
        // re-fire and redirect again.
        dispatch(clearNotFound());
    }, [triggerKey, pathname, navigate, dispatch]);

    return null;
};

export default NotFoundRedirect;
